module.exports = __webpack_public_path__ + "static/img/fljn.5f8778a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fljn.png
// module id = Yue9
// module chunks = 128